import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteIngresosZEDto;
import { columnas } from "./columns";
const resource = resources.CorteIngresosZE;

export class CorteIngresosZEList extends React.PureComponent {

    items = observeResource(resource.query);
    onRegresar = () => history.go("../");

    private onAgregar = async () => {
        if (await kea.yesno("¿Generar corte al día de hoy?", "" + kea.formatDate(new Date()))) {
            const idUsuario = await resources.User.getIdUsuario();
            if (idUsuario != null) {
                var idCorte = await resource.GenerarCorte();
                await kea.message("Corte diario generado");
            } else {
                await kea.message("No ha iniciado sesión");
            }
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Corte ingresos" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"CorteIngresosZEListCookieKey"} items={this.items} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteingresosZE/list/list.tsx